<script>
export default {
  name: "ExpandableCard",
  props: ['item'],
  data() {
    return {
      showDetails: false,
      showTerm:false,
      detailTopHeight: 'auto',
      detailWrapMaxHeight: "0"
    }
  },
  methods: {
    toggleDetails() {
      this.showDetails = !this.showDetails;
    },
    toggleTerms() {
      this.showTerm = !this.showTerm;
    },
    onImageLoad(){
      if(this.item.computeHeight){
        this.$nextTick(() => {
          const cardImg = this.$refs.cardImg
          if (cardImg && cardImg.offsetHeight > 0) {
            this.detailTopHeight = cardImg.offsetHeight
          }else{
            this.detailTopHeight = 'auto';
          }
        })
      }
    },
    splitLines(text){
      if (!text) return [];
      return text.split('\n').filter(line => line.trim() !== '')
    },
    processedHighlights(item) {
      return item.map(h => {
        if (typeof h === 'string') {
          return { type: 'string', content: h }
        } else {
          return {
            type: 'object',
            groupTitle: h.groupTitle,
            lines: this.splitLines(h.text)
          };
        }
      });
    },
    updateDetailHeight() {
      if (this.showDetails) {
        this.$nextTick(() => {
          const el = this.$refs.detailWrap;
          if (el) {
            this.detailWrapMaxHeight = el.scrollHeight
          }
        });
      } else {
        this.detailWrapMaxHeight = 0
      }
    }
  },
  computed: {

  },
  watch:{
    showDetails() {
      this.updateDetailHeight()
    },
    showTerm() {
      this.updateDetailHeight()
    }
  },
  mounted() {
    this.onImageLoad()
  }
}
</script>

<template>
<div class="expandable-card">
  <div class="card-content">
    <div class="card-img">
      <img class="d-xs-block d-lg-none" style="width: 244px" ref="cardImg" :src="item.image" @load="onImageLoad" alt="">
      <div class="d-xs-none d-lg-block">
        <img class="vertical-middle" style="width: 100%" v-if="item.mobileImage" :src="item.mobileImage"  alt="">
      </div>
    </div>
    <div class="card-detail" >
      <div class="detail-top" :style="{height: detailTopHeight + 'px'}">
        <div v-if="item.productType" class="product-type">{{item.productType}}</div>
        <div class="pro-name">{{item.name}}</div>
        <div v-if="item.productIntro" class="product-intro">{{item.productIntro}}</div>
        <div v-if="item.hideAbleIntro && !showDetails" class="product-intro">{{item.hideAbleIntro}}</div>
        <div v-if="item.price" class="pro-price">
          <img src="@/assets/images/icon/monkey_coin_ico.svg" alt="">
          <span>{{item.price}}</span>
        </div>
      </div>
      <div class="detail-wrap" ref="detailWrap" :style="{ maxHeight: detailWrapMaxHeight + 'px' }" v-show="showDetails">
        <p v-if="item.description" style="white-space: pre-line">{{item.description}}</p>
        <div class="detail-wrap-margin" v-if="item.details">
          <h1>Details</h1>
          <div class="detail-wrap-children-margin">
            <p>{{item.details.meetingTime}}</p>
            <p>{{item.details.dismissalTime}}</p>
          </div>
        </div>
        <!-- Itinerary Highlights -->
        <div class="detail-wrap-margin" v-if="item.highlights && item.highlights.length > 0">
          <h1>Itinerary Highlights</h1>
          <ul class="detail-wrap-children-margin">
            <li v-for="(block, index) in processedHighlights(item.highlights)" :key="index">
              <div v-if="block.type === 'object' && true">
                <p class="group-title">{{ block.groupTitle }}</p>
                <div style="margin-bottom: 20px;">
                  <p v-for="(line, index) in block.lines" :key="index" style="white-space: pre-line">{{line}}</p>
                </div>
              </div>
              <p v-else>{{block.content}}</p>
            </li>
          </ul>
        </div>
        <!-- Inclusions -->
        <div class="detail-wrap-margin" v-if="item.inclusions">
          <p>{{ item.inclusions }}</p>
        </div>
        <!-- whatIncludes -->
        <div class="detail-wrap-margin" v-if="item.whatIncludes && item.whatIncludes.length > 0">
          <h1>What‘s Include</h1>
          <ul class="detail-wrap-children-margin">
            <li v-for="(item, index) in item.whatIncludes" :key="index"><p>{{item}}</p></li>
          </ul>
        </div>
        <!-- Address -->
        <div class="detail-wrap-margin" v-if="item.address && item.address.length > 0">
          <p>Address:</p>
          <ul>
            <li v-for="(item, index) in item.address" :key="index"><p>{{item}}</p></li>
          </ul>
        </div>
        <!-- redemDetail -->
        <div class="detail-wrap-margin" v-if="item.redemDetails">
          <h1>Details</h1>
          <div class="detail-wrap-children-margin">
            <p style="white-space: pre-line">{{item.redemDetails}}</p>
          </div>
        </div>
        <!-- redemHaveImgOrPDF -->
        <div class="detail-wrap-margin" v-if="item.redemHaveImgOrPDF">
          <h1>Details</h1>
          <div class="detail-wrap-children-margin">
            <div class="mt-3" v-for="block in item.redemHaveImgOrPDF" :key="block.text">
              <img :src="block.img" alt="" style="width: 100%">
              <a class="d-flex" style="align-items: center" :href="block.pdf.link" target="_blank">
                <img style="width: 30px; margin-right: 1rem" src="@/assets/images\icon\dl-pdf-img.webp" alt="">
                <p>{{block.pdf.text}}</p>
              </a>
            </div>
          </div>
        </div>
        <!-- how to redeem -->
        <div class="detail-wrap-margin" v-if="item.howToRedeem">
          <h1>How to redeem</h1>
          <div class="detail-wrap-children-margin">
            <div v-for="(block,index) in item.howToRedeem" :key="index">
              <p :style="{color: block.dif ? '#BABABA' : '#393939'}">{{block.text}}</p>
            </div>
          </div>
        </div>
        <!-- termAndConditions -->
        <div class="detail-wrap-margin" v-if="item.termAndConditions && item.termAndConditions.length > 0">
          <div class="term-box">
            <div class="terms">
              <div class="itemN-ter">Terms and Conditions</div>
              <div class="itemN-img" @click="toggleTerms">
                <img class="mw-100" :style="{transform: showTerm ? 'rotate(180deg)' : 'rotate(0deg)', transition:'all ease-in .2s'}" src="@/assets/images/icon/Down_Triangle.png" alt="">
              </div>
            </div>
            <ul style="margin-top: 15px;" :class="{ 'show': showTerm }" v-show="showTerm">
              <li v-for="(item, index) in processedHighlights(item.termAndConditions)" :key="index">
                <div v-if="item.type === 'object' && true">
                  <p class="group-title">{{item.groupTitle}}</p>
                  <div style="margin-bottom: 20px;">
                    <p class="text" v-for="(line, index) in item.lines" :key="index" style="white-space: pre-line">{{line}}</p>
                  </div>
                </div>
                <p v-else class="text">{{item.content}}</p>
              </li>
            </ul>
          </div>
        </div>

      </div>
      <div class="d-xs-none d-lg-block m-expand-icon" v-if="item.expandable">
        <img @click.stop="toggleDetails" :style="{transform: showDetails ? 'rotate(180deg)' : 'rotate(0deg)'}" src="@/assets/images/icon/Down_Triangle.png" alt="">
      </div>
    </div>
  </div>
  <div class="expand-icon d-xs-block d-lg-none" v-if="item.expandable">
    <img @click.stop="toggleDetails" :style="{transform: showDetails ? 'rotate(180deg)' : 'rotate(0deg)'}" src="@/assets/images/icon/Down_Triangle.png" alt="">
  </div>
</div>
</template>

<style scoped lang="scss">
@use '@/styles/responsive.scss' as *;
.expandable-card{
  box-shadow: 6px 6px 11px #00000029;
  background: #FFFFFF;
  border-radius: 72px;
  position: relative;
  .card-content{
    display: flex;
    align-items: flex-start;
    column-gap: 36px;
    padding: 36px 94px 36px 39px;

    .card-detail{
      .detail-top{
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        .product-type{
          font-size: 18px;
          line-height: 25px;
          color: #BABABA;
          margin-bottom: 10px;
        }
        .pro-name{
          font-weight: bold;
          font-size: 35px;
          line-height: 45px;
          color: #986F4B;
        }
        .product-intro{
          font-size: 20px;
          line-height: 25px;
          padding: 25px 0 35px;
        }
        .pro-price{
          display: flex;
          align-items: center;
          span{
            margin-left: 10px;
            font-size: 30px;
            line-height: 25px;
          }
        }
      }
      .detail-wrap {
        margin-top: 35px;
        transition: all ease-in-out .1s;
        p{
          font-size: 20px;
          line-height: 25px;
          color: #393939;
        }
        .group-title{
          font-size: 17px;
        }
        h1{
          font-size: 30px;
          line-height: 36px;
          color: #986F4B;
        }
        .detail-wrap-margin{
          margin-top: 30px;
        }
        .detail-wrap-children-margin{
          margin-top: 10px;
        }
        .term-box{
          position: relative;
          overflow: hidden; /* 阻止子元素溢出 */
          ul {
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.3s ease-in-out;

          }
          .show {
            max-height: 1000px; /* 根据内容调整 */
          }
          .terms{
            display: flex;
            align-items: center;
            font-size: 20px;
            color: #393939;
            line-height: 25px;
            .itemN-ter{
              margin-right: 1%;
              border-bottom: 1px solid black;
            }
            .itemN-img{
              cursor: pointer;
              width: 16px;
            }
          }
          .text{
            font-size: 17px;
            color: #707070;
            line-height: 22px;
          }
        }
      }


    }

  }
  .expand-icon{
    position: absolute;
    right: -26px;
    top: 49px;
    img{
      cursor: pointer;
      width: 26%;
      transition: transform ease-in .2s;
    }
  }
}
@include media-max(lg){
  .expandable-card{
    border-radius: 43px;
    .card-content{
      padding: 0;
      flex-direction: column;
      align-items: normal;
      .card-detail{
        position: relative;
        padding: 16px 45px 29px 18px;
        .m-expand-icon{
          position: absolute;
          top: 16px;
          right: 10px;
          img{
            transition: transform ease-in .2s;
            width: 18px;
          }
        }
        .detail-top{

          //.product-type{
          //  font-size: 18px;
          //  line-height: 25px;
          //  color: #BABABA;
          //  margin-bottom: 10px;
          //}
          .pro-name{
            font-size: 30px;
          }
          .product-intro{
            font-size: 20px;
            line-height: 25px;
            padding: 25px 0 35px;
          }
          .pro-price{
            margin-top: 3%;
            span{
              margin-left: 10px;
              font-size: 25px;
              line-height: 25px;
            }
          }
        }
        .detail-wrap {
          margin-top: 28px;
          p{
            font-size: 17px;
            line-height: 25px;
          }
          .group-title{
            font-size: 17px;
          }
          h1{
            font-size: 30px;
            line-height: 36px;
            color: #986F4B;
          }
          .detail-wrap-margin{
            margin-top: 30px;
          }
          .detail-wrap-children-margin{
            margin-top: 10px;
          }
          .term-box{
            position: relative;
            overflow: hidden; /* 阻止子元素溢出 */
            ul {
              max-height: 0;
              overflow: hidden;
              transition: max-height 0.3s ease-in-out;

            }
            .show {
              max-height: 1000px; /* 根据内容调整 */
            }
            .terms{
              display: flex;
              align-items: center;
              font-size: 20px;
              color: #393939;
              line-height: 25px;
              .itemN-ter{
                margin-right: 1%;
                border-bottom: 1px solid black;
              }
              .itemN-img{
                cursor: pointer;
                width: 16px;
              }
            }
            .text{
              font-size: 17px;
              color: #707070;
              line-height: 22px;
            }
          }
        }


      }
    }
  }
}
@include media-max(md){
  .expandable-card{
    border-radius: 50px;
    .card-content{
      padding: 0;
      flex-direction: column;
      align-items: normal;
      .card-detail{
        .detail-top{
          .product-type{
            font-size: 13px;
            margin-bottom: 9px;
          }
          .pro-name{
            font-weight: bold;
            font-size: 17px;
            line-height: 25px;
          }
          .product-intro{
            font-size: 14px;
            line-height: 25px;
            padding: 10px 0 15px;
          }
          .pro-price{
            span{
              margin-left: 9px;
              font-size: 17px;
            }
            img{
              width: 20px;
            }
          }
        }
        .detail-wrap {
          p{
            font-size: 12px;
            line-height: 20px;
          }
          .group-title{
            font-size: 17px;
          }
          .detail-wrap-margin{
            margin-top: 20px;
          }
          .detail-wrap-children-margin{
            margin-top: 10px;
          }
          .term-box{
            .terms{
              font-size: 11px;
              line-height: 25px;
              .itemN-ter{
                margin-right: 3%;
                border-bottom: 1px solid black;
              }
              .itemN-img{
                width: 11px;
              }
            }
            .group-title{
              font-size: 9px;
              line-height: 11px;
            }
            .text{
              font-size: 9px;
              line-height: 11px;
            }
          }
        }


      }
    }
  }
}
</style>